module.exports = __webpack_public_path__ + "static/media/beiyongjin.659348f0.png";